<template>
  <div
    class="label"
    :class="{ active: active }"
  >
    <span
      class="icon"
      :class="direction"
    />

    <div class="text-label">
      <span class="text">{{ city }}</span> ({{ code.slice(0, 3).toUpperCase() }})
    </div>

    <span
      class="close"
      @click="closeLabel"
    />
  </div>
</template>

<script>
  export default {
    props: {
      active: {
        type: Boolean,
        required: true
      },
      direction: {
        type: String,
        required: true
      },
      city: {
        type: String,
        required: true
      },
      code: {
        type: String,
        required: true
      }
    },
    methods: {
      closeLabel() {
        return this.$emit('close')
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';
  @import '~assets/styles/components/route-map.scss';
</style>
